module.exports = __webpack_public_path__ + "static/media/thumb_12.7c98fb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_12.png
// module id = 77
// module chunks = 0